module.exports = __webpack_public_path__ + "img/vehicle_img.838e508b.png";